import { Ente } from './ente';

export type Company = {
  id?: number;
  name?: string;
  vat_number?: string;
  phone_number?: string;
  user_ids?: Array<number>;
  address?: string;
  postal_code?: string;
  region_id?: number;
  province_id?: number;
  city_id?: number;
  country?: string;
  email?: string;
  agency_ids?: number[];
  contract_ids?: number[];
  bank_details?: string;
  logo?: string;
  primary_color?: string;
  assocaf?: boolean;
  terms_and_conditions?: boolean;
  fifth_assignment?: boolean;
  tfr?: boolean;
  exenergy?: boolean;
  weltis?: boolean;
  promoprive?: boolean;
  promoprive_tier?: string;
  serenis?: boolean;
  bsolutionsweb?: boolean;
  agencies?: Ente[];
  realm?: string;
  realm_id?: string;
  logo_h_desktop?: number;
  logo_h_mobile?: number;
};

export class CompanyClass implements Company {
  id = 0;
  name = '';
  vat_number = '';
  phone_number = '';
  user_ids = [];
  address = '';
  postal_code = '';
  region_id = 0;
  province_id = 0;
  city_id = 0;
  country = '';
  email = '';
  agency_ids = [];
  contract_ids = [];
  bank_details = '';
  logo = '';
  primary_color = '';
  assocaf = false;
  terms_and_conditions = false;
  fifth_assignment = false;
  tfr = false;
  exenergy = false;
  weltis = false;
  promoprive = false;
  promoprive_tier = '';
  serenis = false;
  bsolutionsweb = false;
  agencies = [];
  realm = '';
  realm_id = '';
  logo_h_desktop = undefined;
  logo_h_mobile = undefined;
}